<template>
    <div class="page-left vrow yb-layout-margin-menu relative-position" 
        
    :style="{ 'width': widthPX+'px','height':'100% !important' }" :class="{ 'mini': miniNormal==1,'normal':miniNormal!=1 }">
    <!-- :style="{ 'width': widthPX + 'px' ,'height': heightPX + 'px' }" :class="{ 'mini': miniNormal==1,'normal':miniNormal!=1 }"> -->
        <div class="cathectic-shade" v-show="isProcessBet && !sportMiniBet.toggle">
            <div class="shade-fixed">
                <div class="loading-wrap">
                    <div class="img-loading"></div>
                    <div class="text-center loading-text flex items-end justify-center">{{ betLang['BETTING.LBL_PROCESSING'] }}...</div>
                </div>
            </div>
        </div>
        <div id="modal_mini" class="c-main-menu-mini column col" :style="{ height: heightPX+' !important' ,'display': miniNormal==1?'':'none'} ">
            <div class="v-scroll-area fit vrow relative-position" :class="{'bet-list': betting.success}">
                <div class="content-wrap fit">
                    <div class="scroll-header absolute"></div>
                    <div class="fit v-scrollarea q-scrollarea" :style="{ 'width': widthPX + 'px' ,'height': heightPX + 'px' }" >
                        <div class="q-scrollarea__container scroll relative-position fit hide-scrollbar" id="miniScroll">
                            <div class="q-scrollarea__content absolute">
                                <div class="middle-content" style="padding-top: 0px; padding-bottom: 0px;">
                                    <div class="scroll-inner-wrap fit">
                                        <div class="column items-center yb-padding-t5">
                                            <gameBanner :position="'mini'"></gameBanner>
                                            <div class="menu-item menu-item-schedule" @click.prevent="openLivetv()"><img src="assets/images/bet-schedule.png" class="menu_mini-bet" style="width: 22px; height: 22px;"></div>
                                            <div class="menu-item" @click.prevent="showFullLeft(3)"><img src="assets/images/menu_mini_bet.svg" class="menu_mini-bet"></div>
                                            <div class="menu-item" @click.prevent="openRBMarket(market.inPlayMarket.key)">
                                                <img src="assets/images/in-play.png" class="menu_mini-bet" width="22px">
                                            </div>
                                            <div class="dividing-line"></div>
                                            <div class="menu-item" @click.prevent="changeSport(specialEventList['sprtId'],false)" v-if="specialEventStatus">
                                                <span class="q-icon icon c-icon sport-img icon img36 SP"></span>
                                            </div>
                                            <div class="menu-item" @click.prevent="changeSport(sportList[0],true)">
                                                <span class="q-icon icon c-icon sport-img icon icon_simple_N1"></span>
                                            </div>
                                            <template v-for="sport in sportList">
                                                <div class="menu-item" @click.prevent="changeSport(sport, false)">
                                                    <span class="q-icon icon c-icon sport-img icon img36" :class=" sport.sprtId "></span>
                                                </div>
                                            </template>
                                            <div class="dividing-line"></div>
                                            <div v-if="otrBt!=undefined" class="menu-item menu-top menu-virtual menu-border" 
                                                @click.prevent="changeBettype(otrBt,11)">
                                                <span data-v-0d68232c="" class="q-icon icon c-icon sport-img img36" style="width: 18px; height: 18px; background-position: 0px -943.5px;"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="scroll-footer" style="bottom: 0px;"></div>
                </div>
            </div>
        </div>
        <div id="modal_normal" class="c-main-menu column"  :style="{ height: heightPX+' !important' ,'display': miniNormal==0?'':'none'} ">
            <div class="v-scroll-area fit vrow relative-position" :class="{'bet-list': betting.success}" style="margin-left: 0px;">
                <div class="content-wrap fit">
                    <div class="scroll-header absolute" id="scrollHeaderX" style="width: 220px;">
                        <userInfo></userInfo>
                        <gameBanner :position="'l'"></gameBanner>
                        <mainB></mainB>
                    </div>
                    <allSport></allSport> 
                    <template v-if="isUsingPhone() === 0">
                        <div v-if="((oddSelected || betting.success||betting.betcombosuccess||betting.pending||betting.reject||betting.betcomboerror) && openBetForm)" id="scrollFooter" class="scroll-footer" style="bottom: auto;">
                            <bettingFormFooter></bettingFormFooter>
                        </div>
                    </template>
                </div>
            </div>
            <button class="setting collapseExpand"></button>
        </div>
        <div data-v-792cb3ce="" class="menu_toggle-btn yb-flex-center" :class="{ 'mini': miniNormal==1,'normal':miniNormal!=1 }"  v-if="showToggleFloat" @click.prevent="showFullLeft(-1)">
            <img data-v-792cb3ce="" src="assets/images/left_menu_toggle.svg" alt="" >
        </div> 
    </div>
</template>
<script>


import gameBanner from './gameBanner'
import userInfo from './userInfo'
import favorite from './myFavorite'
import allSport from './allSport'
import bettingFormFooter from './bettingFormFooter'
import mainB from './mainB'
import EventBus from '../../../events/event-bus'
import allBetMixin from "@/vue/mixins/allBet";
import {
    mapGetters
} from 'vuex'

export default {
    mixins: [ allBetMixin ],
    components: {
        mainB,
        // gamesMenu,
        userInfo,
        favorite,
        allSport,
        gameBanner,
        bettingFormFooter,
    },
    computed: {
        ...mapGetters([
            'oddSelected',
            'selectedTab',
      	    'resizeWHeight',
            'openBetForm',
            'miniNormal',
            'sportList',
            'market',
            'frameWidthHeight',
            'betting',
            'isProcessBet',
            'sportMiniBet',
            'betLang',
            'pendingFlag',
            'specialEventList',
        ]),
        heightPX: function () {
            return this.$store.getters.frameWidthHeight.height.currentHeight
        },
        widthPX: function () {
            return this.$store.getters.frameWidthHeight.width.LeftPage_current
        },
        showToggleFloat: function () {
            return this.$store.getters.frameWidthHeight.width.minFull > this.$store.getters.frameWidthHeight.width.currentWidth
        },
    },
    data() {
        return {
            isMini: false,
            cBetting: false,
            otrBt:{
                betTypId:"6",
                betTypLang:"Outrights",
                sprtId:"G98",
                // sprtLang:"Soccer",
                // sprtTitleLang:"Soccer",
                tmpltId:"11",
            },
            rbAllSport: {
                "sprtId": "G98",
            },
            specialEventStatus: window.specialEventStatus,
        }
    },
    mounted() {
        if(this.isUsingPhone() === 1){
            const scrollArea = document.querySelector('.betForm-scrollArea-phone');
            const mulpScrollArea = document.querySelector('.mulpbetForm-scrollArea-phone');
            const betSlipArea =  document.querySelector('.betSlip-scrollArea-phone');
            if (scrollArea) {
                scrollArea.style.height = '100% !important';
            }
            if(mulpScrollArea){
                mulpScrollArea.style.height = '100% !important';
            }
            if(betSlipArea){
                betSlipArea.style.height = '100% !important';
            }   
        }
        var Vue = this
        if(Vue.miniNormal==1){
            $('#miniScroll').niceScroll({  
                horizrailenabled: false,
                autohidemode: false, 
                scrollbarid:'leftBarMiniScroll',
                cursorborder: "0px solid #fff", 
                zindex:48,
                railoffset: { left:10 },
                cursordragontouch : true,
            })
        }else{
            $('#normalScroll').niceScroll({  
                horizrailenabled: false,
                autohidemode: false, 
                scrollbarid:'leftBarNormalScroll',
                cursorborder: "0px solid #fff", 
                zindex:45,
                railoffset: { left:10 },
                cursordragontouch : true,
            })
        }
        $('.scroll').hover(
            function () {
                $(this).addClass('active')
            },
            function () {
                $(this).removeClass('active')
            }
        )

        $('.collapseExpand').hover(
            function () {
                $('#leftBar').addClass('selected')
            },
            function () {
                $('#leftBar').removeClass('selected')
            }
        )

        $('.collapseExpand').on('click', function () {
            var widerClass = $('.sidebar-first').hasClass('wider')
            if (widerClass) {
                Vue.isMini = true
                $('.sidebar-first').removeClass('wider')
                $('.category-sportList').removeClass('active')
                $('.sidebar-first').addClass('mini')
            } else {
                Vue.isMini = false
                $('.sidebar-first').removeClass('mini')
                $('.category-sportList').addClass('active')
                $('.sidebar-first').addClass('wider')
            }
        })
        $('#ascrail2000').addClass('mini')
        $('#ascrail2001').addClass('normal')
        /*
        if(Vue.miniNormal==1){
            $('#modal_mini').show()
            $('#modal_normal').hide()
        }else{
            $('#modal_mini').hide()
            $('#modal_normal').show()
        }*/
    },
    updated(){
        
    },
    methods: {
        openLivetv(){
            if(!this.$store.getters.account.previewFlag || this.$store.getters.isLiveOn){
                this.$store.commit("LIVE_SCHECULE", true)
                this.$store.commit('OPEN_RBMARKET', false)
                this.$store.commit("GAMEBANNER_SELECTED", false)
                this.$store.commit('SELECTED_ALLBET', false)
                this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
                this.$store.commit('SELECTED_MATCHALLBET', true)

                if($('.menu-fold2-wrap').hasClass('open')){
                    $('.menu-fold2-wrap').removeClass('open')
                }

                EventBus.$emit('callLivetv')
            } else if (window._hasRedirect) {
                $('.login-redirect-dialog').show();
            }
        },
        openRBMarket(market) {
            // this.$store.commit('SIMPLE_SPORT', null)
            this.$store.commit('MINI_NORMAL', 0);
            EventBus.$emit('viewAccountSetting', false)
            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('SELECTED_ALLBET', false)
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
            this.$store.commit('SELECTED_MATCHALLBET', false)
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
            this.$store.commit('SORTEDRBEVENTLIST', [])
            this.$store.commit('SORTEDEVENTLIST', [])
            
            this.$store.commit('MINI_NORMAL', 3);
            this.$store.commit('SPORTFORECAST_LIST', null)  
            this.$store.commit('OPEN_RBMARKET', true)
            this.$store.commit('SELECTED_MARKET', market)
            EventBus.$emit('refreshOdd', true );
            EventBus.$emit('marketChange', this.$store.getters.market.inPlayMarket.key);
        },
        showFullLeft(val){
            if(val<0){
                if(this.miniNormal==1){
                    val=3
                }else{
                    val=2
                }
            }
            this.$store.commit('MINI_NORMAL', val);
        },
        changeBettype(bettype,otr) {
            EventBus.$emit('refreshOdd', true);
            this.$store.commit('SIMPLE_SPORT', null)
            if(otr==11){
                bettype.tmpltId=11
                this.$store.commit('SELECTED_SPORT', this.rbAllSport)
                EventBus.$emit('refreshOdd', true);
                this.commitBettypeList()
                this.$store.commit('OPEN_RBMARKET', false)
                EventBus.$emit('marketChange', this.$store.getters.selectedMarket==3?'1':this.$store.getters.selectedMarket );
                this.$store.commit('SELECTED_MARKET', this.$store.getters.selectedMarket==3?'1':this.$store.getters.selectedMarket)
            }
            if(bettype.betTypId=='5'){ //mulp clear betcombo setting
                this.$store.commit("IS_BETCOMBO", false);
                this.$store.dispatch('getEarlyEventCountByDate');              
                if(this.$store.getters.betForm.length>0){
                    this.$store.commit("REMOVE_MATCH", { removeAll: true });
                    this.$store.commit("SHOW_BETFORM_MENU", false);
                }
                
            }
            if(this.$store.getters.selectedBettype.betTypId=='5' && this.$store.getters.betForm.length>0){
                this.$store.commit("REMOVE_MATCH", { removeAll: true });
                this.$store.commit("SHOW_BETFORM_MENU", false);
            }

            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
            this.$store.commit('SELECTED_ALLBET', false)
            this.$store.commit('SELECTED_MATCHALLBET', false)
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
            this.$store.commit('SORTEDRBEVENTLIST', [])
            this.$store.commit('SORTEDEVENTLIST', [])
            this.$store.commit('EVENTLIST', [])
            this.$store.commit('MERGE_LEAGUELIST', null)

            if(this.$store.getters.selectedMarket=='1'){
                this.$store.commit('SELECTEDEARLYPARLAYDATE', this.todayDate)
            } else {
                this.$store.commit('SELECTEDEARLYPARLAYDATE', this.allDate)
            }
            // this.$store.commit('SELECTED_LEAGUELIST', [])
            
            EventBus.$emit('viewAccountSetting', false)
            if(bettype){
                //get latest-info used purpose
                if(bettype.betTypId == '5' && this.$store.getters.sportPrevIsMulp) {
                this.$store.commit('SPORT_PREVIOUS_IS_MULP', true)
                } else {
                this.$store.commit('PARLAY_SELECTED', {update : false})
                this.$store.commit('SPORT_PREVIOUS_IS_MULP', false)
                }
                this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(bettype))
            } else {
                var temp = this.$store.getters.selectedBettype
                temp.betTypId = null
                temp.tmpltId = null
                this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(temp))
            }
            EventBus.$emit('sportChange', this.$store.getters.selectedBettype );
        },
        changeSport(sport, simpleSport=false) {
            if(this.$store.getters.selectedSport == sport ){
        //        this.showOdds = !this.showOdds;
            }else{
        //        this.showOdds = true;
            }
            this.$store.commit('MINI_NORMAL', 3);

            if(simpleSport) {
                EventBus.$emit('changeSimpleSport', sport)
            } else {
                EventBus.$emit('leftBarChangeSport', sport)
            }
            /*
            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
            this.$store.commit('SELECTED_ALLBET', false)
            this.$store.commit('SELECTED_MATCHALLBET', false)
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
            this.$store.commit('OPEN_RBMARKET', false)
            EventBus.$emit('refreshOdd', true);
            EventBus.$emit('viewAccountSetting', false)
            this.$store.commit('SELECTED_SPORT', sport)
            this.commitBettypeList()
            this.$store.commit('SELECTED_BETTYPE',  _.cloneDeep(this.$store.getters.bettypeList[0]))
            EventBus.$emit('sportChange', this.$store.getters.selectedBettype );
            if(this.$store.getters.selectedMarket == 3){
                this.$store.commit('SELECTED_MARKET', 1)
            }
            var sideBarMini = $('.sidebar-first').hasClass('mini')

            if(this.selectedSport.sprtId == sport.sprtId){

                if(sideBarMini){
                    var sportListActive = $('.category-sportList.icon-sport'+sport.sprtId).hasClass('active')

                    if(sportListActive){
                        $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                        $('.widgetArea').find('.scroll-content').css('width', '');
                    
                        $('.category-sportList.icon-sport'+sport.sprtId).removeClass('active')
                    }else{
                        $('.widgetArea').find('.scroll-panel').css('overflow', 'visible');
                        $('.widgetArea').find('.expendScore').css('width', '40em');
                        
                        $('.category-sportList.icon-sport'+sport.sprtId).addClass('active')
                    }
                }
            } */
        },
        commitBettypeList() {
        if(this.$store.getters.selectedSport.sprtId == 'G98'){
            this.$store.commit('BETTYPELIST',
                _.filter(
                    this.sportBettypeList,
                    {
                        'sprtId' : 'N1'
                    }
                )
            )
        }else{
            this.$store.commit('BETTYPELIST',
                _.filter(
                    this.sportBettypeList,
                    {
                        'sprtId' : this.$store.getters.selectedSport.sprtId
                    }
                )
            )
        }
    },
    },
    watch: {
    resizeWHeight() {
    //  this.heightPX = this.$store.getters.resizeWHeight + 'px'
    }
  },
}
</script>
<style lang="scss">
//@import "~@/styles/base/global";
//@import "~@/styles/home/contentsLeft/index";
@import "~@/styles/_base/_base_scrollbar";

</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsLeft/leftBar.vue